import type { FC } from "react";

import { CompactItem, type CompactItemProps } from "./CompactItem";
import { RegularItem, type RegularItemProps } from "./RegularItem";

type CartItemProps = RegularItemProps &
  CompactItemProps & {
    blockQuantityAdd?: boolean;
    isLimitEnabled?: boolean;
    variant?: "regular" | "compact";
    maxPrice?: number;
    isRemovable?: boolean;
    isQuantityInputVisible?: boolean;
  };

export const CartItem: FC<CartItemProps> = ({
  isLimitEnabled = false,
  blockQuantityAdd = false,
  variant = "regular",
  isRemovable = true,
  isQuantityInputVisible = true,
  ...props
}) => {
  if (variant === "regular") {
    return (
      <RegularItem
        isLimitEnabled={isLimitEnabled}
        blockQuantityAdd={blockQuantityAdd}
        isRemovable={isRemovable}
        isQuantityInputVisible={isQuantityInputVisible}
        {...props}
      />
    );
  }

  if (variant === "compact") {
    return (
      <CompactItem
        blockQuantityAdd={blockQuantityAdd}
        isRemovable={isRemovable}
        isQuantityInputVisible={isQuantityInputVisible}
        {...props}
      />
    );
  }

  return null;
};
